import {
  event,
  Identifiable,
  Log as LogDto,
  LogType,
  milestone,
  task,
} from "@planzone/dto";
import { RequestedView } from "@root/client/modal/types";
import { UseCases } from "@planzone/core";

const actions: Record<
  LogType,
  (
    log: Identifiable<LogDto>,
    navigate: (path: string) => void,
    pushView: (view: RequestedView) => void,
  ) => void
> = {
  PLANZONE: (log, navigate, pushView) => {
    log.content.includes("CostProfile") && navigate(`/cost-profiles`);
    log.content.includes("projectReportTemplate") &&
      navigate(`/utilities/reports`);
    log.attributes.target &&
      log.attributes.target.includes("projectPortfolios") &&
      navigate(`/portfolios`);
    log.content.includes("GroupPlanzone") && navigate(`/members`);
    log.attributes.target &&
      log.attributes.target.includes("ProjectReportTemplate") &&
      navigate(`/utilities/reports`);
    log.attributes.target &&
      log.attributes.target.includes("ProjectPortfolios") &&
      navigate(`/portfolios`);
    log.content.includes("ProjectStatus") && navigate(`/utilities`);
  },
  ZONE: (log, navigate, pushView) => {
    navigate(`/zones/${log.attributes.uuid}/projects`);
  },
  PROJECT: (log, navigate, pushView) => {
    navigate(`/projects/${log.attributes.uuid}`);
  },
  ACTIVITY: (log, navigate, pushView) => {
    pushView({
      key: UseCases.retrieveList,
      data: { listId: log.attributes.uuid ?? "", isMultiProject: true },
    });
  },
  TASK: (log, navigate, pushView) => {
    pushView({
      key: UseCases.retrieveTask,
      data: {
        task: { ...task, uuid: log.attributes.uuid ?? "" },
        isMultiProject: true,
      },
    });
  },
  EVENT: (log, navigate, pushView) => {
    pushView({
      key: UseCases.retrieveEvent,
      data: {
        event: { ...event, uuid: log.attributes.uuid ?? "" },
        isMultiProject: true,
      },
    });
  },
  MILESTONE: (log, navigate, pushView) => {
    pushView({
      key: UseCases.retrieveMilestone,
      data: {
        milestone: { ...milestone, uuid: log.attributes.uuid ?? "" },
        isMultiProject: true,
      },
    });
  },
  RESOURCE: (log, navigate, pushView) => {
    pushView({
      key: UseCases.retrieveResource,
      data: log.attributes.uuid ?? "",
    });
  },
  UNAVAILABILITY: (log, navigate, pushView) => {
    navigate("/calendar");
  },
  COST_PROFILE: (log, navigate, pushView) => {},
  PLANZONE_RESOURCE: (log, navigate, pushView) => {},
  PROJECT_RESOURCE: (log, navigate, pushView) => {
    navigate(`/projects/${log.attributes.uuid}`);
  },
  PROJECT_RESOURCE_GROUP: (log, navigate, pushView) => {},
  PROJECT_STATUS: (log, navigate, pushView) => {},
  STATUS: (log, navigate, pushView) => {},
  STRATEGIC_AXES: (log, navigate, pushView) => {},
  TIME_RECORD: (log, navigate, pushView) => {},
  AUTHENTICATION: (log, navigate, pushView) => {},
  EMAIL: (log, navigate, pushView) => {},
  NOTIFICATION: (log, navigate, pushView) => {},
  PORTFOLIO: (log, navigate) => navigate(`/portfolios`),
};

function logRedirection(
  log: Identifiable<LogDto>,
): (
  log: Identifiable<LogDto>,
  navigate: (path: string) => void,
  pushView: (view: RequestedView) => void,
) => void {
  return actions[log.logType];
}

export { logRedirection };
